import {createStrokeSVG} from './TEMPLATE'

// tabler: flag
export const Flag_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M5 5a5 5 0 0 1 7 0a5 5 0 0 0 7 0v9a5 5 0 0 1 -7 0a5 5 0 0 0 -7 0v-9',
    'M5 21v-7',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
